import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import { useResto } from '../contexts/RestoContext';
import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';

const CompanyParameters = () => {
    const { t } = useTranslation();
    const { restoData, setRestoData } = useResto();
    const [editedCompany, setEditedCompany] = useState({ ...restoData.company });
    const [showModal, setShowModal] = useState(false);
    const { token } = useAuth();
    const { setIsLoading } = useWebsite();

    useEffect(() => {
        setEditedCompany({ ...restoData.company });
    }, [restoData]);

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditedCompany(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleEditSubmit = async () => {
        try {
            setIsLoading(true);
            const response = await axios.put(
                `${config.apiUrl}company/${restoData.website}`,
                editedCompany,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setRestoData({ ...restoData, company: response.data });
            handleCloseEditModal();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
        setIsLoading(false);
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseEditModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <h2>La société</h2>
            <div className="kubuni-frame">
                <p><strong>Libellé de la société:</strong> {restoData.label}</p>
                <p><strong>Siret:</strong> {editedCompany.siret}</p>
                <p><strong>Adresse:</strong> {editedCompany.address}</p>
                <p><strong>Téléphone:</strong> {editedCompany.phone}</p>
                <p><strong>Numéro RCS:</strong> {editedCompany.rcs}</p>
                <p><strong>Code APE:</strong> {editedCompany.ape}</p>
                <p><strong>Rôle dans la société du responsable du site web:</strong> {editedCompany.ownerRole}</p>
                <Button variant="primary" onClick={handleShowModal} style={{margin:'20px'}}>
                    Mettre à jour
                </Button>
            </div>

            <div className="short-line"></div>

            <Modal show={showModal} onHide={handleCloseEditModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Mettre à jour les paramètres de la société</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="editCompanyLabel">
                            <Form.Label>Libellé de la société</Form.Label>
                            <Form.Control
                                type="text"
                                name="label"
                                value={editedCompany.label}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Siret</Form.Label>
                            <Form.Control
                                type="text"
                                name="siret"
                                value={editedCompany.siret}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Adresse de la société</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                value={editedCompany.address}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>
                        
                        <Form.Group>
                            <Form.Label>Téléphone de la société</Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                value={editedCompany.phone}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Numéro RCS</Form.Label>
                            <Form.Control
                                type="text"
                                name="rcs"
                                value={editedCompany.rcs}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Code APE</Form.Label>
                            <Form.Control
                                type="text"
                                name="ape"
                                value={editedCompany.ape}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Rôle dans la société du responsable du site web</Form.Label>
                            <Form.Control
                                type="text"
                                name="ownerRole"
                                value={editedCompany.ownerRole}
                                onChange={handleEditInputChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        { t('CANCEL') }
                    </Button>
                    <Button variant="primary" onClick={handleEditSubmit}>
                        { t('CONFIRM') }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CompanyParameters;
